export default "__VITE_ASSET__DC0BF9c7__"